import { FixedWidth } from 'ui/utility/fixedWidth';
import {
  IndexTitle,
  IntelligentInsightsSpacedPageHeader,
} from 'modules/intelligentInsights/IntelligentInsights.styles';
import { INTELLIGENT_INSIGHTS } from 'modules/intelligentInsights/constants';

export const IntelligentInsightsHeaderTestId = 'intelligent-insights-header-test-id';

export const IntelligentInsightsHeader = () => (
  <FixedWidth>
    <IntelligentInsightsSpacedPageHeader
      documentTitle="Intelligent Insights"
      data-test={IntelligentInsightsHeaderTestId}
    >
      <IndexTitle>{INTELLIGENT_INSIGHTS}</IndexTitle>
    </IntelligentInsightsSpacedPageHeader>
  </FixedWidth>
);
